import {  Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import './Devlink.css';
const linkStyle={padding:'4px',fontSize:'40px', backgroundColor:'#c3c3c3', color:'#000000', borderRadius:'10px'};


const DevLink = () => {
  return (
    <Stack direction={'row'} justifyContent={'space-evenly'} alignContent={'center'} p={3}>
        <Link to="mailto:tmcvenatt@gmail.com">
            <MailOutlineIcon style={linkStyle} className="devlink mail" />
        </Link>
        <Link to="https://github.com/thomson-mintu" >
            <GitHubIcon style={linkStyle} className="devlink"/>
        </Link>
        <Link to="https://www.linkedin.com/in/thomsonmintu/">
            <LinkedInIcon style={linkStyle} className="devlink linkedin"/>
        </Link>
    </Stack>
  )
}

export default DevLink